import { createFileRoute } from '@tanstack/react-router';

import { ParentSavedPaymentMethodsPage } from '~features/students/ui/parent-saved-payment-methods-page';

const Component = () => {
  const { parentId } = Route.useParams();
  return <ParentSavedPaymentMethodsPage parentId={parentId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/parents/$parentId/saved-payment-methods',
)({
  component: Component,
});
